import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as l } from "../util/date-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
export default class jt {
  constructor(s, t, e, i) {
    (this.h = s),
      (this.v = t),
      (this.gt = e),
      (this.fh = 1e3),
      (i = parseFloat(i)),
      isNaN(i) && (i = 1800),
      i < this.fh / 1e3 &&
        (r.D.info(
          "Specified session timeout of " +
            i +
            "s is too small, using the minimum session timeout of " +
            this.fh / 1e3 +
            "s instead."
        ),
        (i = this.fh / 1e3)),
      (this.ph = i);
  }
  gh(s, t) {
    return new ue(this.v.getUserId(), r.A.wh, s, t.iu, { d: l(s - t.jh) });
  }
  ua() {
    const s = this.h.tu(o.eu.xh);
    return null == s ? null : s.iu;
  }
  Ch() {
    const s = new Date().valueOf(),
      t = this.gt.vl(),
      e = this.h.I(o.q.Gh);
    if (null != e && null == t) return !1;
    const i = null == e || s - e > 1e3 * t;
    return i && this.h.B(o.q.Gh, s), i;
  }
  Fh(s, t) {
    return null == t || (!(s - t.jh < this.fh) && t.Hh < s);
  }
  mo() {
    const s = new Date().valueOf(),
      t = s + 1e3 * this.ph,
      e = this.h.tu(o.eu.xh);
    if (this.Fh(s, e)) {
      let i = "Generating session start event with time " + s;
      if (null != e) {
        let s = e.Wh;
        s - e.jh < this.fh && (s = e.jh + this.kh),
          this.h.qh(this.gh(s, e)),
          (i += " (old session ended " + s + ")");
      }
      (i += ". Will expire " + t.valueOf()), r.D.info(i);
      const n = new _t(r.it.nt(), t);
      this.h.qh(new ue(this.v.getUserId(), r.A.yh, s, n.iu)),
        this.h.uu(o.eu.xh, n);
      return null == this.h.I(o.q.Gh) && this.h.B(o.q.Gh, s), n.iu;
    }
    return (e.Wh = s), (e.Hh = t), this.h.uu(o.eu.xh, e), e.iu;
  }
  Bh() {
    const s = this.h.tu(o.eu.xh);
    null != s &&
      (this.h.Jh(o.eu.xh), this.h.qh(this.gh(new Date().valueOf(), s)));
  }
}
